<div class="mess-summary-dialog">
    <div class="mess-summary-dialog__header">
        <h2 class="mess-summary-dialog__title">Supply Building</h2>
        <div class="mess-summary-dialog__header-actions">
            <button type="button" class="mess-summary-dialog__excel" (click)="onExportExcelClick()">
                <img src="assets/image/vscode-icons_file-type-excel.svg" alt="" width="16" height="16" />
                <span>Export Excel</span>
            </button>
            <button type="button" class="mess-summary-dialog__close" (click)="close()" aria-label="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="sbd" *ngIf="BuildingDetails.length > 0">
        <!-- <div class="sbd__title-row">
            <div class="sbd__title">Supply Building Summary</div>
            <button type="button" class="sbd__collapse-btn" (click)="toggleSupplyBuildingTable()"
                [attr.aria-expanded]="supplyBuildingTableExpanded" aria-label="Toggle supply building table">
                <mat-icon>{{ supplyBuildingTableExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            </button>
        </div> -->

        <div class="sbd__summary">
            <div class="sbd__pill sbd__cardbox_color1">
                <div class="sbd__pillleft">
                    <h1 class="sbd__pill-value">{{ totalCampus }}</h1>
                    <p class="sbd__pill-label">Total Buildings</p>
                </div>
                <div class="sbd__pillright sbd__boxcolor1">
                    <figure class="mb-0">
                        <img src="assets/image/mess/totalcampus.svg" class="sbd__messicon" alt="messicon">
                    </figure>
                </div>
            </div>
            <div class="sbd__pill sbd__cardbox_color2">
                <div class="sbd__pillleft">
                    <h1 class="sbd__pill-value">{{ totalHeadCount }}</h1>
                    <p class="sbd__pill-label">Total Head Count</p>
                </div>
                <div class="sbd__pillright sbd__boxcolor2">
                    <figure class="mb-0">
                        <img src="assets/image/mess/totalheadcount.svg" class="sbd__messicon" alt="messicon">
                    </figure>
                </div>
            </div>
            <div class="sbd__pill sbd__cardbox_color3" *ngIf="perHeadPrice > 0">
                <div class="sbd__pillleft">
                    <h1 class="sbd__pill-value sbd__pill-value--currency">
                        <span class="sbd__pill-currency" aria-hidden="true">₹</span>
                        <span>{{ inrGroupedNumber(perHeadPrice) }}</span>
                    </h1>
                    <p class="sbd__pill-label">Per Head Price</p>
                </div>
                <div class="sbd__pillright sbd__boxcolor3">
                    <figure class="mb-0">
                        <img src="assets/image/mess/perheadprice.svg" class="sbd__messicon" alt="messicon">
                    </figure>
                </div>
            </div>
        </div>

        <div class="sbd__table" *ngIf="supplyBuildingTableExpanded" [class.content--disabled]="readOnly">
            <div class="sbd__thead">
                <div class="campus">Buildings</div>
                <div class="num num--scaits">Scaits Student Strength</div>
                <div class="num">Students</div>
                <div class="num">Employees</div>
                <div class="num">SubStaff</div>
                <div class="num">Others</div>
            </div>

            <div class="sbd__tbody">
                <div class="sbd__tr" *ngFor="let r of BuildingDetails">
                    <div class="campuses">
                        <div class="campuses__name">{{ r.supplyBuildingName }}</div>
                        <!-- <div class="campuses__scaits" *ngIf="r.scaitsStudentCount != null">
                            Student Strength: {{ inrGroupedNumber(r.scaitsStudentCount) }}
                        </div> -->
                    </div>
                    <div class="num num--scaits">
                        <label class="sbd__label">{{ r.scaitsStudentCount != null ? inrGroupedNumber(r.scaitsStudentCount) : '—' }}</label>
                    </div>
                    <div class="num">
                        <input type="number" inputmode="numeric" class="sbd__input"
                            [value]="formatStudentCountInput(r)"
                            (input)="onStudentCountInput(r, $event)"
                            (blur)="onStudentCountBlur(r, $event)"
                            (keydown)="onStudentCountKeydown($event, r)"
                            placeholder="0"
                            [readonly]="readOnly"
                            [attr.maxlength]="studentCountMaxLength(r)" />
                    </div>
                    <div class="num">
                        <input type="number" class="sbd__input" [(ngModel)]="r.employeeCount"
                            (input)="onCountChange()" (keydown)="blockDecimalPoint($event)" placeholder="0" [readonly]="readOnly" maxlength="3" />
                    </div>
                    <div class="num">
                        <input type="number" class="sbd__input" [(ngModel)]="r.subStaffCount"
                            (input)="onCountChange()" (keydown)="blockDecimalPoint($event)" placeholder="0" [readonly]="readOnly" maxlength="3" />
                    </div>
                    <div class="num">
                        <input type="number" class="sbd__input" [(ngModel)]="r.visitorsCount"
                            (input)="onCountChange()" (keydown)="blockDecimalPoint($event)" placeholder="0" [readonly]="readOnly" maxlength="3" />
                    </div>
                </div>

                <div class="sbd__tr sbd__tr--total">
                    <div class="campus">Total</div>
                    <div class="num num--scaits">{{ inrGroupedNumber(totalStudentStrength) }}</div>
                    <div class="num">{{ inrGroupedNumber(totalStudents) }}</div>
                    <div class="num">{{ inrGroupedNumber(totalEmployee) }}</div>
                    <div class="num">{{ inrGroupedNumber(totalSubStaff) }}</div>
                    <div class="num">{{ inrGroupedNumber(totalVisitors) }}</div>
                </div>
            </div>
        </div>

        <p class="sbd__note">Note: Above values are average of Breakfast, Lunch, Snack, Dinner.</p>
    </div>

    <div class="mess-summary-dialog__empty" *ngIf="!BuildingDetails.length">
        No supply building details found.
    </div>

    <div class="mess-summary-dialog__footer">
        <button type="button" class="sbd__btn sbd__btn--ghost" (click)="close()">Cancel</button>
        <button type="button" class="sbd__btn" (click)="submit()" [disabled]="readOnly || !BuildingDetails.length">
            Submit
        </button>
    </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
